import supabase from '../supabase/supabase';

export async function loadAllUsers() {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('id, email, name, created_at')
    .order('created_at', { ascending: false });
  if (error) throw new Error(error.message);
  return data || [];
}

export async function upsertUserProfile(user) {
  if (!user) return;
  const { error } = await supabase.from('user_profiles').upsert({
    id: user.id,
    email: user.email || '',
    name: user.user_metadata?.name || user.user_metadata?.full_name || '',
  }, { onConflict: 'id' });
  if (error) console.error('upsertUserProfile failed:', error);
}